import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import { MarginAnalyzerPanel } from "@/components/MarginAnalyzerPanel";
import PayRateCalculatorPanel from "@/components/PayRateCalculatorPanel";
import { useAuth } from "@/context/AuthContext";
import { canAccessRoute } from "@/lib/accessPolicy";
import { api, formatApiError } from "@/lib/api";

const TABS = [
  { key: "pay-rate", label: "Pay rate calculator" },
  { key: "margin", label: "Margin analyzer", route: "/margin-analyzer" },
];

export default function PricingToolsPage({ initialTab }) {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [contracts, setContracts] = useState([]);
  const [error, setError] = useState("");
  const tabs = TABS.filter((item) => !item.route || canAccessRoute(item.route, user?.role));
  const requested = initialTab || searchParams.get("tab");
  const tab = tabs.some((item) => item.key === requested) ? requested : "pay-rate";

  useEffect(() => {
    api.get("/contracts")
      .then((response) => setContracts(response.data))
      .catch((requestError) => setError(formatApiError(requestError)));
  }, []);

  return (
    <div className="app-shell" data-testid="pricing-tools-shell">
      <AppSidebar activeItem="Pricing tools" />
      <div className="app-content">
        <AppHeader />
        <main className="dashboard-page pay-rate-page" data-testid="pricing-tools-page">
          <div className="page-intro">
            <div>
              <p className="eyebrow">FINANCE</p>
              <h1>Pricing tools</h1>
              <p className="page-subtitle">Set safe W-2 and 1099 offers from reviewed contract rates, and model contract margins before TAG commits.</p>
            </div>
          </div>
          <nav className="data-admin-tabs pricing-tabs" data-testid="pricing-tools-tabs">
            {tabs.map((item) => (
              <button key={item.key} type="button" className={tab === item.key ? "active" : ""} data-testid={`pricing-tab-${item.key}`} aria-selected={tab === item.key} onClick={() => setSearchParams({ tab: item.key }, { replace: true })}>
                {item.label}
              </button>
            ))}
          </nav>
          {error && <p className="form-message error-message" data-testid="pay-rate-contracts-error">{error}</p>}
          {tab === "pay-rate" && <PayRateCalculatorPanel canManage={user?.role === "system_administrator"} contracts={contracts} standalone />}
          {tab === "margin" && <MarginAnalyzerPanel />}
        </main>
      </div>
    </div>
  );
}
